import React, { Component } from "react";
import "../App.css";
import styled from "styled-components";

class Socials extends Component {
	render() {
		return (
			<SocialsWrapper>
				{/* <a href="https://www.facebook.com/sol1tarydancer" target="_blank" rel="noopener noreferrer">
					<img alt="facebook" src="https://res.cloudinary.com/wy/image/upload/sd/facebook.svg"></img>
				</a> */}
				<a href="https://www.instagram.com/solitarydancer_" target="_blank" rel="noopener noreferrer">
					<img alt="instagram" src="https://res.cloudinary.com/wy/image/upload/sd/instagram-2.svg"></img>
				</a>
				<a href="https://privatepossessions.bandcamp.com/releases" target="_blank" rel="noopener noreferrer">
					<img alt="bandcamp" src="https://res.cloudinary.com/wy/image/upload/sd/bandcamp-2.svg"></img>
				</a>

				<a
					href="https://open.spotify.com/artist/676jXFZDJC6IqruhBrZiIr?si=On212qorQNmpFkE7aEkwiQ"
					target="_blank"
					rel="noopener noreferrer"
				>
					<img alt="spotify" src="https://res.cloudinary.com/wy/image/upload/sd/spotify-2.svg"></img>
				</a>
				<a href="https://soundcloud.com/solitary-dancer" target="_blank" rel="noopener noreferrer">
					<img alt="soundcloud" src="https://res.cloudinary.com/wy/image/upload/sd/soundcloud-2.svg"></img>
				</a>
				<a href="mailto:info@solitarydancer.net" target="_blank" rel="noopener noreferrer">
					<img alt="email" src="https://res.cloudinary.com/wy/image/upload/sd/email-2.svg"></img>
				</a>
			</SocialsWrapper>
		);
	}
}

export default Socials;

const SocialsWrapper = styled.div`
	right: 0;
	left: 0;
	position: relative;
	color: black;
	margin: 0 auto;
	padding: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	padding-bottom: 75px;
	padding-top: 10px;

	img {
		/* max-height: 20px; */
		width: auto;
		height: 20px;
		cursor: pointer;
		opacity: 1;
	}

	img:hover {
		opacity: 1;
	}
	a {
		margin-left: 12px;
	}

	@media (min-width: 768px) {
		right: 25px;
		top: 25px;
		left: initial;
		position: fixed;
		display: block;
		padding-bottom: 0;
		padding-top: 0;
		margin: 0;
		display: flex;
		justify-content: center;
		align-items: center;
	}
`;
